function toggleClickableStim()
{  
	if (stimContainers[1].className=="clickableImage")
	{
		for (var i = 1; i <= window.stimFieldsMax; i++){stimContainers[i].className="nonclickableImage";}
	}
	else
	{
		for (var i = 1; i <= window.stimFieldsMax; i++){stimContainers[i].className="clickableImage";}
	}
}